import { MGLayoutCountValues } from 'components/MGLayoutIcon/MGLayoutIcon';
import { VideoSessionName } from 'state-machines/new-video-session-state';

export enum Layout {
  hero = 'hero',
  same = 'same',
}

export enum ViewMode {
  fullscreen = 'fullscreen',
  inline = 'inline',
}

export enum TheaterMode {
  theater = 'theater',
  default = 'default',
}

export enum Screen {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
}

export interface PlayerGame {
  bracketId?: number;
  isPrimary: boolean;
  sessionName?: VideoSessionName;
}

export type Context = {
  initialGameId?: number;
  screens: PlayerGame[];
  focus?: Screen;
  isFullScreenActive: boolean;
  isHeroSizeActive: boolean;
  isPrimaryFullScreenActive: boolean;
  isMGAllowed: boolean;
  activeScreenCount: number;
  maxStreams: number;
  createDate: number;
  firstLoad?: boolean;
};

export type EnterMultiGameEvent = { type: 'ENTER_MULTI_GAME'; focus: Screen.One };
export type ExitMultiGameEvent = { type: 'EXIT_MULTI_GAME' };
export type ResetContextEvent = { type: 'RESET_CONTEXT'; bracketId?: number };
export type EnterFullScreenEvent = { type: 'ENTER_FULL_SCREEN' };
export type ExitFullScreenEvent = { type: 'EXIT_FULL_SCREEN' };
export type EnterPrimaryFullScreenEvent = { type: 'ENTER_PRIMARY_FULL_SCREEN' };
export type ExitPrimaryFullScreenEvent = { type: 'EXIT_PRIMARY_FULL_SCREEN' };
export type EnterHeroSizeEvent = { type: 'ENTER_HERO_SIZE' };
export type ExitHeroSizeEvent = { type: 'EXIT_HERO_SIZE' };
export type MgLoadedEvent = { type: 'MG_LOADED' };
export type SetScreenCount = { type: 'SET_SCREEN_COUNT'; screens: MGLayoutCountValues };
export type TileClickAction = { type: 'TILE_CLICK'; bracketId: number; alerts?: string; canAddToMG?: boolean };
export type PlayerClickAction = { type: 'PLAYER_CLICK'; bracketId: number; goFullScreen?: boolean };
export type UpdateScreenSessionName = {
  type: 'UPDATE_SCREEN_SESSION_NAME';
  bracketId: number;
  sessionName: VideoSessionName;
};

export type Event =
  | TileClickAction
  | PlayerClickAction
  | UpdateScreenSessionName
  | SetScreenCount
  | EnterMultiGameEvent
  | ExitMultiGameEvent
  | EnterFullScreenEvent
  | ExitFullScreenEvent
  | EnterHeroSizeEvent
  | ExitHeroSizeEvent
  | EnterPrimaryFullScreenEvent
  | ExitPrimaryFullScreenEvent
  | MgLoadedEvent
  | ResetContextEvent;

export type AnalyticsViewModeChangeEvent =
  | EnterPrimaryFullScreenEvent
  | ExitPrimaryFullScreenEvent
  | EnterMultiGameEvent
  | ExitMultiGameEvent
  | EnterFullScreenEvent
  | ExitFullScreenEvent
  | EnterHeroSizeEvent
  | ExitHeroSizeEvent;
